module.exports = __webpack_public_path__ + "static/media/chinese.2a393e62.jpg";